import { Box, Divider, Typography } from "@mui/material";
import ProfitLossResumedCard from "./profit-loss-resumed";
import ProfitLossDashboard from "./profit-loss";
import CryptoPriceSlider from "../../components/crypto-price-slider";

export default function DashboardCards() {
  return (
    <>
      <Box mt={3} mb={1}>
        <Typography
          variant="h4"
          fontWeight={700}
          sx={{ color: 'primary.main', letterSpacing: 1 }}
        >
          Dashboard
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Visão geral do teu portfolio de criptomoedas
        </Typography>
        <Divider sx={{ mt: 2, borderColor: 'rgba(255,215,0,0.15)' }} />
      </Box>
      <Box mt={3}>
        <CryptoPriceSlider />
      </Box>
      <Box>
        <Box mt={3}>
          <ProfitLossResumedCard />
        </Box>
        <Box mt={3}>
          <ProfitLossDashboard />
        </Box>
      </Box>
    </>
  )
}